import React from 'react'

const TriangleUp = () => (
  <svg width="11" height="6" viewBox="0 0 11 6" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.5 5.5L5.5 0.5L0.5 5.5L10.5 5.5Z" fill="currentColor" />
  </svg>
)

export default TriangleUp
